import { CatalogProcessor } from './CatalogProcessor';
import { validateJsonObject } from "Core/data/Helpers";

export class Driver {

  constructor() {
    this.boundGetProcessItem = this.getProcessItem.bind(this);
  }

  executeArray = (items, itemsExists) => {
    return CatalogProcessor.executeArray(
      items, 
      itemsExists, 
      'drivers', 
      this.boundGetProcessItem, 
      'name' //order by name
    );
  }

  execute = (item, itemsExists) => {
    return CatalogProcessor.execute(
      item, 
      itemsExists, 
      'drivers', 
      this.boundGetProcessItem, 
      'name'
    );
  }

  getProcessItem = (item, newItem, itemsExists) => {
    let tags = item?.tags || [];
    let tagIds = item?.tagIds || '';

    // Priority 1: If newItem has tags array, use it directly
    if (newItem?.tags && Array.isArray(newItem?.tags)) {
      tags = newItem?.tags;
      tagIds = newItem?.tagIds !== undefined ? newItem?.tagIds : item?.tagIds;
    } 
    // Priority 2: If newItem has tagIds, reconstruct tags from catalog
    else if (newItem?.tagIds !== undefined) {
      tagIds = newItem.tagIds;
      tags = CatalogProcessor.reconstructTagsFromIds(tagIds, itemsExists || {});
    }

    // Simplified avatarFile handling
    const avatarFile = newItem?.avatarFile ? {
      id: newItem.avatarFile.id,
      repositoryId: newItem.avatarFile.repositoryId,
      repositoryType: newItem.avatarFile.repositoryType,
      repositoryCode: newItem.avatarFile.repositoryCode,
      repositoryPath: newItem.avatarFile.repositoryPath,
      fileKey: newItem.avatarFile.fileKey,
      originalName: newItem.avatarFile.originalName
    } : item?.avatarFile || null;

    return {
      ...item,
      id: String(newItem.id || item.id),
      driverId: String(newItem?.driverId || item?.driverId || item?.id),
      name: newItem?.title || newItem?.name || item.name,
      status: newItem.status !== undefined ? newItem.status : item.status,
      avatarFileId: newItem.avatarFileId !== undefined ? newItem.avatarFileId : item.avatarFileId,
      avatarFile,
      tempAvatarUrl: newItem.tempAvatarUrl !== undefined ? newItem.tempAvatarUrl : item.tempAvatarUrl,
      tagIds,
      tags,
      externalId: newItem?.externalId !== undefined ? newItem?.externalId : item?.externalId,
      driver_tz_id: newItem.driver_tz_id ? newItem.driver_tz_id : item.idTimeZone,
      supervisorId: newItem.supervisorId !== undefined ? newItem.supervisorId : item.supervisorId,
      licenseNumber: newItem?.licenseNumber !== undefined ? newItem?.licenseNumber : item?.licenseNumber,
      licenseCountry: newItem?.licenseCountry !== undefined ? newItem?.licenseCountry : item?.licenseCountry,
      licenseState: newItem?.licenseState !== undefined ? newItem?.licenseState : item?.licenseState,
      driverPin: newItem?.driverPin !== undefined ? newItem?.driverPin : item?.driverPin,
      hosRulesetIds: newItem?.hosRulesetIds !== undefined ? newItem?.hosRulesetIds : item?.hosRulesetIds,
      hosExempt: newItem?.hosExempt !== undefined ? newItem?.hosExempt : item?.hosExempt,
      hosExemptComment: newItem?.hosExemptComment !== undefined ? newItem?.hosExemptComment : item?.hosExemptComment,
      specialDutyStatuses: newItem?.specialDutyStatuses !== undefined ? newItem?.specialDutyStatuses : item?.specialDutyStatuses,
      email: newItem?.email !== undefined ? newItem?.email : item?.email,
      phone: undefined,
      cell: newItem?.cell !== undefined ? newItem?.cell : item?.cell,
      notifyByEmail: newItem?.notifyByEmail !== undefined ? newItem?.notifyByEmail : item?.notifyByEmail,
      notifyBySms: newItem?.notifyBySms !== undefined ? newItem?.notifyBySms : item?.notifyBySms,
      updated_at: newItem.updated_at || item.updated_at,
      updatedBy: newItem.updatedBy || item.updatedBy,
      connected: newItem?.connected !== undefined ? newItem?.connected : item?.connected,
      lastConnected: newItem?.lastConnected !== undefined ? newItem?.lastConnected : item?.lastConnected,
      fsmDriver: newItem?.fsmDriver !== undefined ? newItem?.fsmDriver : item?.fsmDriver,
      fsmUsername: newItem?.fsmUsername !== undefined ? newItem?.fsmUsername : item?.fsmUsername,
      idTimeZone: newItem?.idTimeZone || newItem.driver_tz_id || item.idTimeZone,
      supervisor: newItem?.supervisor !== undefined ? newItem?.supervisor : item?.supervisor,
      unitId: newItem?.unitId !== undefined ? String(newItem?.unitId) : item?.unitId,
      unit: newItem?.unit !== undefined ? newItem?.unit : item?.unit,
      contactInfo: newItem?.contactInfo !== undefined ? newItem?.contactInfo : item?.contactInfo,
      keyfob: newItem?.keyfob !== undefined ? newItem?.keyfob : item?.keyfob,
      empNum: newItem?.empNum !== undefined ? newItem?.empNum : item?.empNum,
    }
  }

}